import type { MediaApiVersionRow, MediaApiVersionSummary, MediaApiVersionsResponse } from "../types/mediaApiVersion";

function normalizeVersions(list: unknown): string {
    const arr = Array.isArray(list) ? list : [];
    const uniq = Array.from(
        new Set(arr.filter((v): v is string => typeof v === "string" && v.trim() !== "" && v !== "-"))
    );
    return uniq.join(", ");
}

export function buildMediaApiVersionRows(data: MediaApiVersionsResponse): {
    rows: MediaApiVersionRow[];
    summary: MediaApiVersionSummary;
} {
    const v1 = data?.v1 ?? {};
    const channels = Object.keys(v1).sort((a, b) => a.localeCompare(b));

    const rows: MediaApiVersionRow[] = [];

    for (const channel of channels) {
        const value = v1[channel];

        if (Array.isArray(value)) {
            rows.push({
                channel,
                subChannel: "",
                versions: normalizeVersions(value),
                rowSpan: 1,
            });
            continue;
        }

        if (value && typeof value === "object") {
            const subEntries = Object.entries(value).sort(([a], [b]) => a.localeCompare(b));
            const span = Math.max(1, subEntries.length);

            subEntries.forEach(([subChannel, versions], idx) => {
                rows.push({
                    channel: idx === 0 ? channel : "",
                    subChannel,
                    versions: normalizeVersions(versions),
                    rowSpan: idx === 0 ? span : 1,
                });
            });

            continue;
        }

        // 예상 밖 형식: 빈 행 1개로 처리
        rows.push({
            channel,
            subChannel: "",
            versions: "",
            rowSpan: 1,
        });
    }

    return {
        rows,
        summary: {
            itemsLength: rows.length,
            channelCount: channels.length,
        },
    };
}